import React, { useState } from "react";
import style from "./Styles.module.css";
import ImageLoader from "../ImageLoader";

function CollapsibleOptionView({ title, options, className = "", defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const rootClass = [style.collapsibleView, className].join(" ").trim();

  // Render options depending on type
  const renderOptions = () => {
    if (!options) return null;

    // Case: array of objects
    if (Array.isArray(options)) {
      return options.map((item, index) => (
        <div key={index} className={style.item}>
          <p>{item.value}</p>
        </div>
      ));
    }

    // Case: single object
    if (typeof options === "object") {
      return (
        <div className={style.row}>
          <p>{options.value}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className={rootClass}>
      <div onClick={() => setIsOpen(!isOpen)} className={style.header}>
        <div className={style.headerContents}>
          <p className={style.title}>{title}</p>
        </div>

        <ImageLoader
          className={`${style.toggleView} ${style.transition} ${isOpen ? style.rotate180 : style.rotate0
            }`}
          src={
            isOpen
              ? require("../../media/icons/icon_minus.png")
              : require("../../media/icons/icon_plus.png")
          }
          alt="toggle icon"
        />
      </div>

      {/* Options */}
      <div
        className={`${style.transition} ${isOpen ? style.open : style.closed
          }`}
      >
        <div className={style.contents}>{renderOptions()}</div>
      </div>
    </div>
  );
}

export default CollapsibleOptionView;